import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c2a07f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "o-seatmapSelection__noSelectionNotice"
}
const _hoisted_2 = {
  key: 2,
  class: "o-seatmapSelection__notice"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Event configuration is invalid - selected price levels have different currencies!", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 3,
  class: "o-seatmapSelection__priceLevelsContainer"
}
const _hoisted_6 = ["data-js", "data-qa"]
const _hoisted_7 = { class: "o-seatmapSelection__priceLevelHeader" }
const _hoisted_8 = ["data-qa"]
const _hoisted_9 = { class: "o-seatmapSelection__ticketAction" }
const _hoisted_10 = { class: "o-seatmapSelection__priceLevelDescription" }
const _hoisted_11 = {
  key: 0,
  class: "o-seatmapSelection__priceLevelNotice"
}
const _hoisted_12 = {
  key: 0,
  class: "a-notice -error"
}
const _hoisted_13 = { class: "o-seatmapSelection__ticketList" }
const _hoisted_14 = {
  key: 0,
  class: "o-seatmapSelection__ticketContainer"
}
const _hoisted_15 = { class: "o-seatmapSelection__ticket" }
const _hoisted_16 = { class: "o-seatmapSelection__ticketWrapper" }
const _hoisted_17 = ["data-qa"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sector", -1))
const _hoisted_21 = ["data-qa"]
const _hoisted_22 = {
  key: 0,
  class: "o-seatmapSelection__ticketOption bottom-padding"
}
const _hoisted_23 = { class: "o-seatmapSelection__ticketName" }
const _hoisted_24 = { class: "o-seatmapSelection__priceItems" }
const _hoisted_25 = { class: "o-seatmapSelection__pricePrimary" }
const _hoisted_26 = {
  key: 0,
  class: "o-seatmapSelection__pricePrimary"
}
const _hoisted_27 = {
  key: 1,
  class: "o-seatmapSelection__ticketTypeContainer"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "o-seatmapSelection__ticketName" }
const _hoisted_30 = { class: "o-seatmapSelection__dropdownContent" }
const _hoisted_31 = { class: "o-seatmapSelection__priceItems padding-right" }
const _hoisted_32 = { class: "o-seatmapSelection__pricePrimary" }
const _hoisted_33 = {
  key: 0,
  class: "o-seatmapSelection__pricePrimary"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "o-seatmapSelection__ticketName" }
const _hoisted_36 = { class: "o-seatmapSelection__priceItems" }
const _hoisted_37 = { class: "o-seatmapSelection__pricePrimary" }
const _hoisted_38 = {
  key: 0,
  class: "o-seatmapSelection__pricePrimary"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "a-notice -error"
}
const _hoisted_41 = {
  key: 1,
  class: "a-notice -error"
}
const _hoisted_42 = {
  key: 2,
  class: "a-notice -error"
}
const _hoisted_43 = ["data-qa"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PromotionPanel = _resolveComponent("PromotionPanel")!
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_button_component = _resolveComponent("button-component")!
  const _component_TicketFeeInfo = _resolveComponent("TicketFeeInfo")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'-is-fullHeight' : !_ctx.isMobile}, "o-seatmapSelection__list clearfix"])
  }, [
    (_ctx.promotionStore.availablePromotions.length)
      ? (_openBlock(), _createBlock(_component_PromotionPanel, {
          key: 0,
          "event-id": _ctx.data.configuration.eventId,
          class: _normalizeClass([{'padding-top': _ctx.isMobile}, "o-seatmapSelection__promoPanel"])
        }, null, 8, ["event-id", "class"]))
      : _createCommentVNode("", true),
    (!_ctx.seatmapStore.getStructuredSelection || _ctx.seatmapStore.getStructuredSelection.length === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" Select your tickets by clicking on available seats or standing area ")
        ])), [
          [_directive_translate, { key: _ctx.Translation.Seatmap_select_tickets }]
        ])
      : _createCommentVNode("", true),
    (_ctx.seatmapStore.hasMismatchedCurrencies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.seatmapStore.getStructuredSelection?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seatmapStore.getStructuredSelection, (priceLevel, pricelevelIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: pricelevelIndex,
              "data-js": 'pricelevel-' + pricelevelIndex,
              class: _normalizeClass([{
                        '-topMargin': !_ctx.isMobile && !_ctx.panelState.isPromotionPanelActive() && !_ctx.promotionStore.active
                     }, "o-seatmapSelection__priceLevel"]),
              "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_TICKET
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "o-seatmapSelection__priceLevelTitle",
                  "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_TITLE
                }, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ backgroundColor: priceLevel.selectionInfo.color }),
                    class: "a-coloredCircle"
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(priceLevel.selectionInfo.priceCategoryName), 1)
                ], 8, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_icon_component, {
                    "icon-id": _ctx.IconName.Cross,
                    onClick: ($event: any) => (_ctx.removeSelection(priceLevel.selectionInfo))
                  }, null, 8, ["icon-id", "onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(priceLevel.selectionInfo.description), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seatmapStore.validation.priceCategories, (priceCategoryError, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (priceCategoryError.id === priceLevel.selectionInfo.priceCategoryId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (priceCategoryError.max)
                          ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_12, [
                              _createTextVNode(" You can only add " + _toDisplayString(priceLevel.selectionInfo.maxTickets) + " to selection from " + _toDisplayString(priceLevel.selectionInfo.name), 1)
                            ])), [
                              [_directive_translate, {
                                   key: _ctx.Translation.Seatmap_max_price_level_restriction_error,
                                   keyValues: JSON.stringify({
                                   'placeholder-price-category-name': priceLevel.selectionInfo.name,
                                   'placeholder-max-amount': priceLevel.selectionInfo.maxTickets }),
                                   identifierStart: '{',
                                   identifierEnd: '}',
                                   }]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                (priceLevel.selectionInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: "o-seatmapSelection__ticketInformation",
                            "data-qa": _ctx.PerformanceQASelectors.TICKET_INFORMATION
                          }, [
                            (priceLevel.selectionInfo.seat && priceLevel.selectionInfo.row)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", null, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                      _createTextVNode("Row ")
                                    ])), [
                                      [_directive_translate, { key: _ctx.Translation.Row_label }]
                                    ]),
                                    _createElementVNode("span", null, ": " + _toDisplayString(priceLevel.selectionInfo.row), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                      _createTextVNode("Seat ")
                                    ])), [
                                      [_directive_translate, { key: _ctx.Translation.Seat_label }]
                                    ]),
                                    _createElementVNode("span", null, ": " + _toDisplayString(priceLevel.selectionInfo.seat), 1)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (priceLevel.selectionInfo.entranceName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                          _createTextVNode("Entrance")
                                        ])), [
                                          [_directive_translate, { key: _ctx.Translation.Entrance_label }]
                                        ]),
                                        _createElementVNode("span", null, ": " + _toDisplayString(priceLevel.selectionInfo.entranceName), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (priceLevel.selectionInfo.blockName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("span", null, ": " + _toDisplayString(priceLevel.selectionInfo.blockName), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ], 8, _hoisted_17)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([{'-changedMargin': priceLevel.selectionInfo.ticketTypes.length === 1}, "o-seatmapSelection__ticketType"]),
                        "data-qa": _ctx.PerformanceQASelectors.TICKET_TYPE
                      }, [
                        (priceLevel.selectionInfo.ticketTypes.length === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("p", _hoisted_23, _toDisplayString(priceLevel.selectionInfo.ticketTypes[0].name), 1),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.currencyHandler.displayPrimaryCurrency(
                                                        priceLevel.selectionInfo.ticketTypes[0].price)), 1),
                                (_ctx.currencyHandler.isSecondaryCurrencyDisplayed)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, " /" + _toDisplayString(_ctx.currencyHandler.displaySecondaryCurrency(
                                                        priceLevel.selectionInfo.ticketTypes[0].price)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{'-has-border' : _ctx.isTicketOpen(priceLevel.selectionInfo)}, "o-seatmapSelection__typeSelection"]),
                                onClick: ($event: any) => (_ctx.setOpenedSelectionTo(priceLevel.selectionInfo, pricelevelIndex))
                              }, [
                                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.getActiveTicketTypeFor(priceLevel.selectionInfo).name), 1),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.currencyHandler.displayPrimaryCurrency(
                                                                _ctx.getActiveTicketTypeFor(priceLevel.selectionInfo).price)), 1),
                                    (_ctx.currencyHandler.isSecondaryCurrencyDisplayed)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, " / " + _toDisplayString(_ctx.currencyHandler.displaySecondaryCurrency(
                                                                _ctx.getActiveTicketTypeFor(priceLevel.selectionInfo).price)), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode(_component_IconComponent, {
                                    "icon-id": _ctx.IconName.Arrow,
                                    class: _normalizeClass(_ctx.isTicketOpen(priceLevel.selectionInfo) ?
                                                        'o-seatmapSelection__collapseArrow'
                                                        : 'o-seatmapSelection__expandArrow')
                                  }, null, 8, ["icon-id", "class"])
                                ])
                              ], 10, _hoisted_28),
                              _createVNode(_TransitionGroup, { name: "slide" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceLevel.selectionInfo.ticketTypes, (ticketType, index) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass([{ '-active': ticketType.active }, "o-seatmapSelection__typeSelection"]),
                                      key: index,
                                      onClick: ($event: any) => (_ctx.handleTicketTypeSelection(priceLevel.selectionInfo, ticketType))
                                    }, [
                                      _createElementVNode("p", _hoisted_35, _toDisplayString(ticketType.name), 1),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.currencyHandler.displayPrimaryCurrency(ticketType.price)), 1),
                                        (_ctx.currencyHandler.isSecondaryCurrencyDisplayed)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, " /" + _toDisplayString(_ctx.currencyHandler.displaySecondaryCurrency(ticketType.price)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 10, _hoisted_34)), [
                                      [_vShow, _ctx.openedSelection && _ctx.isTicketOpen(priceLevel.selectionInfo)]
                                    ])
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ])),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceLevel.selectionInfo.ticketTypes.filter(
                                        item => item.active), (activeTicketType) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seatmapStore.validation.ticketTypes, (ticketTypeError, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (ticketTypeError.id === activeTicketType.priceId &&
                                            !ticketTypeError.max)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      (ticketTypeError.min)
                                        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_40, [
                                            _createTextVNode(" Minimum amount restriction not reached")
                                          ])), [
                                            [_directive_translate, {
                                                           key: _ctx.Translation.Seatmap_min_ticket_restriction_error,
                                                           keyValues: JSON.stringify({
                                                           'placeholder-min-value': activeTicketType.min,
                                                           'placeholder-rebate-name': activeTicketType.name,
                                                           'placeholder-price-category-name':
                                                               priceLevel.selectionInfo.name }),
                                                           identifierStart: '{',
                                                           identifierEnd: '}',
                                                           }]
                                          ])
                                        : _createCommentVNode("", true),
                                      (ticketTypeError.max)
                                        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_41, [
                                            _createTextVNode(" Max amount restriction exceeded")
                                          ])), [
                                            [_directive_translate, {
                                                           key: _ctx.Translation.Seatmap_max_ticket_restriction_error,
                                                           keyValues: JSON.stringify({
                                                           'placeholder-rebate-name': activeTicketType.name,
                                                           'placeholder-price-category-name':
                                                               priceLevel.selectionInfo.name }),
                                                           identifierStart: '{',
                                                           identifierEnd: '}',
                                                           }]
                                          ])
                                        : _createCommentVNode("", true),
                                      (ticketTypeError.step)
                                        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_42, [
                                            _createTextVNode("Ticket grouping restriction not satisfied")
                                          ])), [
                                            [_directive_translate, {
                                                    key: _ctx.Translation.Seatmap_step_ticket_restriction_error,
                                                    keyValues: JSON.stringify({
                                                        'ticket-type-name': activeTicketType.name,
                                                        'step-restriction-amount': activeTicketType.step }),
                                                    identifierStart: '{',
                                                    identifierEnd: '}',
                                                }]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 64))
                        }), 256))
                      ], 10, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      "data-js": "submit-action",
      "data-qa": _ctx.PerformanceQASelectors.SUBMIT_BUTTON,
      class: "o-seatmapSelection__submitAction"
    }, [
      _createVNode(_component_button_component, {
        label: _ctx.submitSelectionLabel,
        active: _ctx.seatmapStore.validation.isValid,
        "icon-name": _ctx.IconName.Cart,
        "secondary-label": _ctx.currencyHandler.displaySecondaryCurrency(_ctx.seatmapStore.totalSelectionAmount),
        onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelState.triggerAddToCart())),
        "qa-selector": _ctx.PerformanceQASelectors.PRICE_LEVEL_SUBMIT
      }, null, 8, ["label", "active", "icon-name", "secondary-label", "qa-selector"]),
      _createVNode(_component_TicketFeeInfo, {
        "currency-handler": _ctx.currencyHandler,
        "fee-list": _ctx.seatmapStore.fees,
        "ticket-price-list": _ctx.getSelectedTicketsPriceList(),
        "has-opacity": _ctx.totalTicketsSelected === 0
      }, null, 8, ["currency-handler", "fee-list", "ticket-price-list", "has-opacity"])
    ], 8, _hoisted_43)
  ], 2))
}